import { giftModule } from '@/store/gift/module'
import { isPromise } from '@/store/utils'
import { router } from '@/router'

const getValidGift = () => {
    const validGift = giftModule.state.validGift.value

    if (isPromise(validGift)) {
        return null
    } else {
        return validGift
    }
}

const getGiftError = () => {
    return giftModule.state.giftError
}

const getGiftTier = () => {
    const validGift = giftModule.state.validGift.value

    if (isPromise(validGift)) {
        return null
    } else {
        return validGift?.tier
    }
}

const getRedemptionToken = () => {
    return giftModule.state.redemptionToken
}

const getIsShowingRedeemGiftModal = () => {
    const route = router.currentRoute.value
    if (!route.matched.some(r => r.meta?.requiresAuth)) {
        return false
    }

    return giftModule.state.isShowingRedeemGiftModal
}

export default {
    getValidGift,
    getGiftError,
    getIsShowingRedeemGiftModal,
    getGiftTier,
    getRedemptionToken,
}
